import { css } from 'glamor'
import Typography from "typography"
//import kirkhamTheme from "typography-theme-kirkham"
import ArchiaTTF from "../assets/fonts/Archia-Regular.ttf"
import {
    MOBILE_MEDIA_QUERY,
    TABLET_MEDIA_QUERY
} from 'typography-breakpoint-constants'

/*kirkhamTheme.baseFontSize = '14px'
kirkhamTheme.headerColor = '#3F404F'
kirkhamTheme.bodyColor = '#000000'
kirkhamTheme.headerFontFamily = kirkhamTheme.bodyFontFamily = [
    'Archia',
    'Arial',
    'serif'
]
kirkhamTheme.overrideThemeStyles = ({ rhythm }, options) => ({
    a: {
        color: '#000000',
        textDecoration: 'none'
    },
    figcaption: {
        textTransform: 'uppercase',
        paddingLeft: '2em'
    }
})*/
//const typography = new Typography(kirkhamTheme)
css.global('@font-face', {
    fontFamily: 'Archia', 
    src: 'url(' + ArchiaTTF + ')'
})

css.global('html, body, h1, h2, h3, h4, h5, h6', {
    fontFamily: 'Archia'
})

const typography = new Typography({
    baseFontSize: '14px',
    headerColor: '#3F404F',
    baseFontSize: '18px',
    baseLineHeight: 1.44,
    scaleRatio: 2.15,
    blockMarginBottom: 0.75,
    //headerFontFamily: ['Archia', 'serif'],
    //bodyFontFamily: ['Archia', 'serif'],
    bodyColor: 'hsla(0,0%,0%,0.8)',
    headerWeight: 400,
    bodyWeight: 400,
    boldWeight: 400,
    overrideStyles: ({ adjustFontSizeTo, scale, rhythm }, options) => ({
        a: {
            color: '#000000',
            textDecoration: 'none'
        },
        blockquote: {
            ...scale(1 / 5),
            color: '#696969',
            fontStyle: 'italic',
            paddingLeft: rhythm(13 / 16),
            marginLeft: 0,
            borderLeft: `${rhythm(3 / 16)} solid #cccccc}`,
        },
        'blockquote > :last-child': {
            marginBottom: 0,
        },
        'blockquote cite': {
            ...adjustFontSizeTo(options.baseFontSize),
            color: options.bodyColor,
            fontWeight: options.bodyWeight,
        },
        'blockquote cite:before': {
            content: '"— "',
        },
        figcaption: {
            textTransform: 'uppercase',
            paddingLeft: '2em'
        },
        [MOBILE_MEDIA_QUERY]: {
            blockquote: {
            marginLeft: rhythm(-3 / 4),
            marginRight: 0,
            paddingLeft: rhythm(9 / 16),
        }
    }
  })
})
module.exports = typography


// WEBPACK FOOTER //
// ./src/utils/typography.js